import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import backgroundImg from './img/background.jpg'
import divider from './img/divider.png'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro413">
      <div className="index screen">
        <div className="bg-IO3Fu5">
          <img
            className="background-TXD5zb bp2-animate-enter"
            src={background || backgroundImg}
            alt="Background"
          />
        </div>
        <div className="button-IO3Fu5">
          <p
            className="site-de-casamento-e-fWuS1D"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-fWuS1D smart-layers-pointers">
            <div className="pular-introduo-DGFCer" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-IO3Fu5 bp2-animate-enter3">
          <div className="m-fltOP2 valign-text-middle bp2-animate-enter1 notranslate">
            {coupleSimplifiedName.bride}
          </div>
          <img className="divider-fltOP2" src={divider} alt="Divider" />
          <div className="e-fltOP2 valign-text-middle bp2-animate-enter2 notranslate">
            {coupleSimplifiedName.groom && coupleSimplifiedName.groom}
          </div>
        </div>
      </div>
      <div className="animated-intro-u8211-large screen">
        <div className="bg-GCTxQa">
          <img
            className="background-ddPiak bp1-animate-enter"
            src={background || backgroundImg}
            alt="Background"
          />
        </div>
        <div className="button-GCTxQa">
          <p
            className="site-de-casamento-e-OTTU7T"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-OTTU7T smart-layers-pointers">
            <div className="pular-introduo-JFieAx" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-GCTxQa bp1-animate-enter3">
          <div className="m-O5oSxw valign-text-middle lg---title-xl bp1-animate-enter1 notranslate">
            {coupleSimplifiedName.bride}
          </div>
          <img className="divider-O5oSxw" src={divider} alt="Divider" />
          <div className="e-O5oSxw valign-text-middle lg---title-xl bp1-animate-enter2 notranslate">
            {coupleSimplifiedName.groom && coupleSimplifiedName.groom}
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
